import {
    apiRequest,
    undanganpelantikanList,
    undanganpelantikanActive,
    undanganpelantikanInactive
} from "../../../../../services/adapters/kepegawaian/undanganPelantikanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", undanganpelantikanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", undanganpelantikanInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", undanganpelantikanActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository